import React, { useState } from "react";
import AnimateCC from "../../../animate";
import { MC } from "../../../animate/utils";
import { PreloaderComponent } from "../../../loaders/PreloaderComponent";
import { PesahGame } from "./PesahGame";

const PesahGameComponent: React.FC<{}> = () => {
    const game = React.useRef(new PesahGame());
    const directLink = new URLSearchParams(window.location.search).get("path");
    const [fromDirectLink] = useState(directLink);
    const [screenReady, setScreenReady] = useState(false);
    console.log("from direct link", fromDirectLink);

    return (
        <>
            {fromDirectLink && !screenReady && <PreloaderComponent name="plain" />}
            <AnimateCC
                base="/special_games/pesah"
                animationName="pesah"
                onLoaded={(mc: MC) => {
                    setScreenReady(true);
                    game.current.loaded(mc);
                }}
            />
        </>
    );
};
export default PesahGameComponent;
